// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b47ef39","455":"9522a947","701":"09c2bef3"}[chunkId] + ".chunk.js";
};